import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { useStateWithSyncExternalData } from '../../shared/hooks/stateWithSyncExternalData';
import { useFilterDispatchers } from '../../services/modelInteraction';
import FilterActions from '../../shared/ui/FilterActions';
import DropdownSelect from '../../../../components/dropdownSelect';
import FilterContainer from '../../shared/ui/FilterContainer';
import { useRegionsData } from '../../services/queries/regionsData';
import {
  housesFilterNames,
  selectors,
  actionCreators,
  sliceKeys,
} from '../../model';

const { selectFilter } = selectors[sliceKeys.houses];
const { filterChanged } = actionCreators[sliceKeys.houses];

const MemoizedRegionsSelect = memo(RegionsSelect);

const HousesListFilter = ({ onClose }) => {
  const storeFilter = useSelector(selectFilter);

  const { state: filter, setState: onChange } =
    useStateWithSyncExternalData(storeFilter);

  const { onApply, onReset } = useFilterDispatchers({
    createAction: filterChanged,
    value: filter,
    cb: onClose,
  });

  return (
    <FilterContainer>
      <MemoizedRegionsSelect
        value={filter?.[housesFilterNames.regions]}
        onChange={onChange}
      />
      <FilterActions
        onReset={storeFilter ? onReset : onClose}
        onApply={storeFilter !== filter ? onApply : onClose}
      />
    </FilterContainer>
  );
};

export default HousesListFilter;

const emptyArr = Object.freeze([]);
const { dataTypes } = useRegionsData;

function RegionsSelect({ value, onChange }) {
  const { data, isFetching } = useRegionsData({
    dataType: dataTypes.options,
  });

  return (
    <DropdownSelect
      options={!data || data === 'Error' ? emptyArr : data}
      loading={isFetching}
      multiple={true}
      value={value}
      onChange={(value) => onChange({ name: housesFilterNames.regions, value })}
      label="Районы"
    />
  );
}
